import * as React from 'react'
import MenuColumnsIcon from '../icons/ui/MenuColumns'

class ListColumnsMenu extends React.Component<any, any> {
  constructor(props: any) {
    super(props)

    this.state = {
      visible: false
    }
  }

  public render() {
    const modalStyles: any = {
      display: this.state.visible ? 'block' : 'none',
      right: '0px',
      top: '19px'
    }

    return (
      <div className='cursor-pointer mt1 relative' onMouseEnter={this.mouseEnter} onMouseLeave={this.mouseLeave}>
        {this.props.icon ? this.props.icon : <MenuColumnsIcon />}
        <div className='z2 bg-white shadow absolute' style={modalStyles}>
          {this.props.children}
        </div>
      </div>
    )
  }

  public mouseEnter = (e: React.MouseEvent<HTMLElement>) => {
    this.setState({ visible: true })
  }

  public mouseLeave = (e: React.MouseEvent<HTMLElement>) => {
    this.setState({ visible: false })
  }
}

export default ListColumnsMenu



// WEBPACK FOOTER //
// ./src/components/ui/ListColumnsMenu.tsx